import React from 'react';
import './unorderedListWithCheckbox.scss';

interface Props {
  listItems: string[];
}

export const UnorderedListWithCheckbox: React.FC<Props> = (props) => {
  return (
    <ul className='unordered-list-with-checkbox'>
      {props.listItems.map((i) => (
        <li key={i}>{i}</li>
      ))}
    </ul>
  );
};
